import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: '0 !important',
  },
}));

export default useStyles;
